var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component/icon/ic_Place"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined Shape"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9.99992C9.47276 9.99992 10.6667 8.80601 10.6667 7.33325C10.6667 5.86049 9.47276 4.66659 8 4.66659C6.52724 4.66659 5.33333 5.86049 5.33333 7.33325C5.33333 8.80601 6.52724 9.99992 8 9.99992ZM8 8.66659C7.26362 8.66659 6.66667 8.06963 6.66667 7.33325C6.66667 6.59687 7.26362 5.99992 8 5.99992C8.73638 5.99992 9.33333 6.59687 9.33333 7.33325C9.33333 8.06963 8.73638 8.66659 8 8.66659Z",
    fill: "#696974"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7.24662C2 3.97829 4.68871 1.33325 8 1.33325C11.3113 1.33325 14 3.97829 14 7.24662C14 8.86102 13.3396 10.373 12.1967 11.4728L8.46756 15.1418C8.20813 15.3971 7.79192 15.3971 7.53247 15.1418L3.79823 11.4682C2.65629 10.3638 2 8.85603 2 7.24662ZM11.2669 10.5172C12.1571 9.66055 12.6667 8.49384 12.6667 7.24662C12.6667 4.7196 10.5798 2.66659 8 2.66659C5.42025 2.66659 3.33333 4.7196 3.33333 7.24662C3.33333 8.49002 3.83976 9.65352 4.72922 10.5137L7.99997 13.7314L11.2669 10.5172Z",
    fill: "#696974"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.fac2d2c6810d2434e8fbb3a5bee72684.svg";
export { ForwardRef as ReactComponent };